
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import RegionService from '@/services/region.service';
import { IResRegion } from '@/common/interface/region';
import SupplyService from '@/services/supply.service';
import { CDistributorList } from '@/models/supply.model';

@Component
export default class SelectDistributorModal extends Vue {
  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  @lazyInject(RegionService)
  regionService!: RegionService;

  visible = false;
  loading = false;

  provinces: IResRegion[] = [];

  filterForm: any = {
    code: '',
    companyName: '',
    province: undefined,
  };

  dataSource: any[] = [];

  selectedRowKeys: number[] = [];
  selectedRecords: any[] = [];

  columns = [
    {
      title: '编码',
      dataIndex: 'sdCode',
      align: 'center',
      width: 120,
    },
    {
      title: '公司全称',
      dataIndex: 'companyName',
      align: 'center',
    },
    {
      title: '省份',
      dataIndex: 'province',
      align: 'center',
      width: 100,
    },
    {
      title: '联系人',
      dataIndex: 'contactName',
      align: 'center',
      width: 100,
    },
    {
      title: '联系电话',
      dataIndex: 'contactPhone',
      align: 'center',
      width: 130,
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      width: 90,
      scopedSlots: { customRender: 'status' },
    },
  ];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  get rowSelection() {
    return {
      type: 'radio',
      selectedRowKeys: this.selectedRowKeys,
      onChange: this.onSelectChange,
      getCheckboxProps: (record: any) => ({
        props: {
          disabled: record.status !== 1,
        },
      }),
    };
  }

  customRow(record: any) {
    return {
      on: {
        click: () => {
          if (record.status !== 1) return;
          this.selectedRowKeys = [record.id];
          this.selectedRecords = [record];
        },
      },
    };
  }

  onSelectChange(selectedRowKeys: number[], selectedRows: any[]) {
    this.selectedRowKeys = selectedRowKeys;
    this.selectedRecords = selectedRows;
  }

  open() {
    this.visible = true;
    this.filterForm = {
      code: '',
      companyName: '',
      province: undefined,
    };
    this.selectedRowKeys = [];
    this.selectedRecords = [];
    this.pagination.current = 1;
    this.getProvinces();
    this.getList();
  }

  async getProvinces() {
    if (this.provinces.length) {
      return;
    }
    const res = await this.regionService.allRegions();
    if (res && res.length) {
      this.provinces = [...res];
    }
  }

  async getList() {
    this.loading = true;
    try {
      const params: any = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        status: 1,
      };
      if (this.filterForm.code) params.sd_code = this.filterForm.code;
      if (this.filterForm.companyName) {
        params.company_name = this.filterForm.companyName;
      }
      if (this.filterForm.province) params.province = this.filterForm.province;
      const res = await this.supplyService.getDistributorList(params);
      if (res && res.list) {
        this.dataSource = res.list.map((item: any) => CDistributorList.from(item));
        this.pagination.total = res.total || 0;
      } else {
        this.dataSource = [];
        this.pagination.total = 0;
      }
    } finally {
      this.loading = false;
    }
  }

  search() {
    this.pagination.current = 1;
    this.getList();
  }

  resetQuery() {
    this.filterForm = {
      code: '',
      companyName: '',
      province: undefined,
    };
    this.pagination.current = 1;
    this.getList();
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getList();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = size;
    this.getList();
  }

  handleOk() {
    if (!this.selectedRecords.length) {
      this.$message.warning('请选择一个经销商');
      return;
    }
    this.$emit('select', this.selectedRecords[0]);
    this.handleCancel();
  }

  handleCancel() {
    this.visible = false;
    this.selectedRowKeys = [];
    this.selectedRecords = [];
  }
}
